/**
 * Checks if webpage is running inside an iframe.
 */
const isIframe = (): boolean => globalThis.self !== globalThis.top;

export { isIframe };
